<ion-card class="job-card">
  <ion-grid *ngIf="feed.json_details">
    <!-- Checkbox and Logo -->
    <ion-row>
      <ion-col size="9">
        <!-- Job Title and Company -->
        <div class="title" (click)="feedService.openDetails(feed.id)">{{feed.header}}</div>
        <span class="detail">
          {{feed.json_details.company}} <ion-icon name="star" class="star-icon"></ion-icon> {{feed.json_details.domain}}
        </span>
        <div style="color:blue">{{feed.json_details.website}}</div>
      </ion-col>
      <ion-col size="3">
        <img [src]="feed.image_urls[0]" *ngIf="feed.image_urls && feed.image_urls.length > 0">
        <img src="./assets/imgs/news_job.png" *ngIf="!feed.image_urls || feed.image_urls.length == 0"
          class="card-image">
      </ion-col>
    </ion-row>

    <!-- Experience, Salary, Location -->
    <ion-row>
      <ion-col size="4" class="detail">
        <ion-icon name="calendar-outline" class="icon"></ion-icon>
        {{feed.json_details.experience}} Exp
      </ion-col>
      <ion-col size="4" class="detail">
        <span class="icon margin5px">₹</span> {{feed.json_details.salary}}
      </ion-col>
      <ion-col size="4" class="detail">
        <ion-icon name="location-outline" class="icon"></ion-icon>
        {{feed.json_details.location}}
      </ion-col>
      <ion-col size="4" class="detail">
        <ion-icon name="calendar-outline" class="icon"></ion-icon>
        {{feed.event_date | fancyDateOnly}}
      </ion-col>
      <ion-col size="4" class="detail">
        {{feed.json_details.minimum_qualification}}
      </ion-col>
      <ion-col size="4" class="detail">
        {{feed.json_details.type}}
      </ion-col>
    </ion-row>

    <!-- Job Description -->
    <ion-row>
      <ion-col size="12">
        <div class="bold">{{feed.json_details.role}}</div>
        <p class="jobDes">
          {{feed.description}}
        </p>
      </ion-col>
    </ion-row>

    <!-- Skill Tags -->
    <div *ngIf="feed.json_details.skills">
      <ion-badge *ngFor="let item of feed.json_details.skills.split(',')" mode="ios"
        class="margin2px">{{item}}</ion-badge>
    </div>

    <!-- Footer (Hide and Save) -->
    <ion-row style="background-color: #eee; margin:10px -10px -10px">
      <ion-col size="1.5">
        <span *ngIf="feed.creator">
          <img width="35px" height="35px" [src]="feed.creator.url" *ngIf="feed.creator && feed.creator.url"
            class="circular">
          <ion-icon name="person-circle-outline" *ngIf="!feed.creator.url" class="avatarPlaceholder"></ion-icon>
        </span>
      </ion-col>
      <ion-col size="7.5" (click)="feedService.openDetails(feed.id)">
        <div class="font1_1" *ngIf="feed.creator">{{feed.creator.name}}</div>
        <div class="font0_8">{{feed.created_at | fancyDate}}</div>
      </ion-col>

      <ion-col size="1">
        <ion-icon name="logo-whatsapp" (click)="feedService.share(feed)"></ion-icon>
      </ion-col>
      <ion-col size="1">
        <ion-icon (click)="showEmojiBox = !showEmojiBox" name="heart-outline"></ion-icon>
      </ion-col>
      <ion-col size="1">
        <ion-icon (click)="feedService.openDetails(feed.id)" name="chatbubble-outline"></ion-icon>
      </ion-col>
    </ion-row>
  </ion-grid>
  <ion-row *ngIf="showEmojiBox" class="emojiBox">
    <ion-col size="2" *ngFor="let emoji of reaction.emojiList" (click)="clickEmoji(emoji)" class="font1_5">
      {{emoji}}
    </ion-col>
  </ion-row>
</ion-card>